module.exports = __webpack_public_path__ + "static/media/pattern-quotes.83ba950c.svg";